import parse from 'url-parse'

export const query = parseQuery()

function parseQuery () {
  if (!window.location) {
    return {}
  }

  return parse(window.location, true).query
}
